import DetailRrhhLeave from '@/requests/leaves/views/rrhh/detailRequestRrhh';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/_authenticated/requests/viewLeave/$id/',
)({
    component: LeaveDetailPage,
})

function LeaveDetailPage() {
    const { id } = Route.useParams();
    return <DetailRrhhLeave leaveId={id} />
}